<img *ngIf="imgSrc" [src]="imgSrc" />
<h2 *ngIf="title">{{title}}</h2>
<h3 *ngIf="msg">{{msg}}</h3>
